<div>
  <div class="logo-title-wrapper">
    <img class="img-logo" src="../assets/images/lindskrog_logo.png" alt="Lindskrog logotyp" />
  </div>
  <p class="description">
    Din QR-kod för inpassering till parkeringen
  </p>
  <img class="img-qr" [src]="qrUrl">

  <p class="description">Välkommen!</p>
</div>